import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/core'
import Form from 'components/Form/Form'
import { handleAPIError } from 'components/Form/helpers'
import FormInput from 'components/Form/Input'
import React, { useCallback, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { createScope } from 'store/scopes'
import * as Yup from 'yup'
import Authorize from 'components/Authorize'

const getDefaultValues = () => ({
  id: '',
  description: '',
})

const getValidationSchema = () =>
  Yup.object({
    id: Yup.string().required(`required`),
    description: Yup.string().required(`required`),
  })

function ScopeCreate() {
  const toast = useToast()

  const dispatch = useDispatch()

  const { isOpen, onOpen, onClose } = useDisclosure(false)

  const defaultValues = useMemo(() => getDefaultValues(), [])
  const validationSchema = useMemo(() => getValidationSchema(), [])

  const form = useForm({
    defaultValues,
    validationSchema,
  })

  const onSubmit = useCallback(
    async ({ id, description }) => {
      try {
        await dispatch(createScope({ id, description }))
        onClose()
      } catch (err) {
        handleAPIError(err, { form, toast })
      }
    },
    [dispatch, form, onClose, toast]
  )

  return (
    <Authorize permissions="auth:Scope:create">
      <Button onClick={onOpen}>Create</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <Form form={form} onSubmit={onSubmit}>
            <ModalHeader>Create New Scope</ModalHeader>

            <ModalCloseButton type="button" />

            <ModalBody>
              <FormInput name="id" label={`ID`} />
              <FormInput name="description" label={`Description`} />
            </ModalBody>

            <ModalFooter>
              <Button type="button" mr={3} onClick={onClose}>
                Close
              </Button>
              <Button type="submit">Create</Button>
            </ModalFooter>
          </Form>
        </ModalContent>
      </Modal>
    </Authorize>
  )
}

export default ScopeCreate
